import React from 'react';
import { Typography } from '@mui/material';
import { TableSelection } from '../SelectableTable.types';

export const SelectedRecordCountDisplay: React.FC<{
  selection?: TableSelection;
  selectedItems?: number;
  totalItems: number;
  style?: React.CSSProperties;
}> = ({ selectedItems, selection, totalItems, children, style }) => {
  const selectedCount: number = selection
    ? selection.isAll
      ? totalItems
      : selection.items.length
    : selectedItems || 0;
  return selectedCount > 0 ? (
    <div style={{ display: 'inline-flex', alignItems: 'center', minWidth: '200px', ...style }}>
      <Typography sx={{ fontWeight: 400, fontSize: '12px', color: '#2C2D3E', margin: '3px 10px 0px 23px' }}>
        {`Zaznaczono ${selectedCount} z ${totalItems}`}
      </Typography>
      {children}
    </div>
  ) : null;
};
